import "@babel/polyfill"
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import Cookies from 'js-cookie'
import Analytics from 'react-router-ga'
import { Auth } from 'aws-amplify'
import * as Sentry from '@sentry/browser'
import { createBooking } from './actions/bookingActions'
import BookingHomePage from './containers/BookingHomePage'
import SignupPage from './containers/SignupPage'
import BookingSignup from './containers/BookingSignupPage'
import BookingWhenPage from './containers/BookingWhenPage'
import BookingParticipantsPage from './containers/BookingParticipantsPage'
import BookingPeopleDetailsPage from './containers/BookingPeopleDetailsPage'
import BookingPaymentPage from './containers/BookingPaymentPage'
import BookingCompletedPage from './containers/BookingCompletedPage'
import BookingPricing from './components/BookingPricing'
import StripeGiftcardsWrapper from './containers/StripeGiftcardsWrapper'
import DashboardPage from './containers/DashboardPage'
import MembershipRenewalPage from './containers/MembershipRenewalPage'
import BookingDetailsPage from './containers/BookingDetailsPage'
import BookingEditPage from './containers/BookingEditPage'
import { fetchSkus } from './lib/booking'


class CPHillRouter extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      booking: {}
    }
    this.googleAnalyticsId = window.gaData && Object.keys(window.gaData)[0]
  }

  componentWillMount() {
    const { props, state } = this

    // Attempt get from local storage if not in redux
    return (Object.keys(state.booking).length === 0)
      ? Cookies.get('booking') && props.createBooking(JSON.parse(Cookies.get('booking')))
      : true
    // ? localStorage.getItem('booking') && props.createBooking(JSON.parse(localStorage.getItem('booking')))
  }

  async componentDidMount() {
    const skus = await fetchSkus()
    this.setState({ skus })

    try {
      const user = await Auth.currentAuthenticatedUser()  
      Sentry.configureScope((scope) => {
        scope.setUser({ email: user.attributes.email });
      })

      // if (window.Autopilot) {
      //   window.Autopilot.run("associate", {
      //     Email: user.attributes.email
      //   })
      // }
      
    } catch(error) { /* Do nothing */ }
  }

  render () {
    const { skus } = this.state
    return (
      <Router>
        <Route render={({ location }) => ( 
          <Analytics id={this.googleAnalyticsId}>

            <Switch location={location}>
              <Route path="/" component={SignupPage} exact />
              <Route path="/signup" component={SignupPage} exact />
              <Route path="/pricing" exact render={props => <BookingPricing {...props} skus={skus} />} />
              <Route path="/giftcards" render={props => <StripeGiftcardsWrapper {...props} skus={skus} />} exact />
              <Route path="/dashboard" render={props => <DashboardPage {...props} skus={skus} />} exact />
              <Route path="/renewals" render={props => <MembershipRenewalPage {...props} skus={skus} />} exact />

              {/* Booking */}
              <Route path="/bookings" component={BookingHomePage} exact />
              <Route path="/bookings/invitation/:invitationId" component={BookingHomePage} exact />
              <Route path="/bookings/when" component={BookingWhenPage} exact />
              <Route path="/bookings/participants" component={BookingParticipantsPage} exact />
              <Route path="/bookings/people-details" render={props => <BookingPeopleDetailsPage {...props} skus={skus} />} exact />
              <Route path="/bookings/signup" component={BookingSignup} exact />
              <Route path="/bookings/payment" render={props => <BookingPaymentPage {...props} skus={skus} />} exact />
              <Route path="/bookings/completed" render={props => <BookingCompletedPage {...props} skus={skus} />} exact />
              <Route path="/bookings/:id" component={BookingDetailsPage} exact />
              <Route path="/bookings/:id/edit" component={BookingEditPage} exact />
            </Switch>
          </Analytics>
        )}
        />
      </Router>
    )
  }
}

const mapStateToProps = state => ({
  booking: state.booking
})

export default connect(mapStateToProps, { createBooking })(CPHillRouter)